import React, { useState } from 'react';
import Lottie from 'react-lottie';
import { Waypoint } from 'react-waypoint';
import { StLottie } from './style.css';
import objLottie from '../../moving/data.json';

// const phrases = require.context('../../phrases/', false, /\.json$/)

const LottieObj = ({}) => {
	const [ shouldPlay, updateShouldPlay ] = useState(false);
	const [ direction, updateDirection ] = useState(1);

	const handleEnterViewport = (scrollEvent) => {
		if (scrollEvent.currentPosition === 'inside' && scrollEvent.previousPosition === 'below') {
			updateDirection(1);
		}
		if (scrollEvent.currentPosition === 'inside' && scrollEvent.previousPosition === 'above') {
			updateDirection(-1);
		}
		updateShouldPlay(true);
	};
	const handleExitViewport = (scrollEvent) => {
		if (scrollEvent.currentPosition === 'above' && scrollEvent.previousPosition === 'inside') {
			updateDirection(-1);
		}
		if (scrollEvent.currentPosition === 'below' && scrollEvent.previousPosition === 'inside') {
			updateDirection(1);
		}

		updateShouldPlay(false);
	};

	const jsonsrc = objLottie;
	const defaultOptions = {
		loop: true,
		autoplay: false,
		animationData: jsonsrc,
		renderer: 'svg',
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice'
		}
	};
	return (
		<StLottie>
			<div className="wrap">
				{/* <Waypoint onEnter={handleEnterViewport} onLeave={handleExitViewport}> */}
				<div>
					<Lottie options={defaultOptions} />
				</div>
				{/* </Waypoint> */}
			</div>
		</StLottie>
	);
};

export default LottieObj;
